import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import ScrollToTop from './ScrollToTop';

// Pages Components
import About from './Pages/About/About';
import Automation from './Pages/Automation/Automation';
import Blogs from './Pages/Blogs/Blogs';
import Career from './Pages/Carrer/Career';
import Jobs from './Pages/Carrer/Jobs';
import ChildSafety from './Pages/ChildSafety/ChildSafety';
import Contact from './Pages/Contact/Contact';
import EnergyEfficiency from './Pages/EnergyEfficiency/EnergyEfficiency';
import Events from './Pages/Events/events';
import Exhibitions from './Pages/Exhibitions/Exhibitions';
import FabricShade from './Pages/FabricShade/FabricShade';
import FAQ from './Pages/FAQ/FAQ';
import FilterInspiration from './Pages/FilterInspiration/FilterInspiration';
import Home from './Pages/Home/Home';
import Innovation from './Pages/Innovation/Innovation';
import Inspiration from './Pages/Inspiration/Inspiration';
import LCP from './Pages/LightControlPrivacy/LCP';
import News from './Pages/News/News';
import OperatingSystems from './Pages/OperatingSystems/OperatingSystems';
import PhotosGallery from './Pages/PhotosGallery/PhotosGallery';
import Presence from './Pages/Presence/Presence';
import PrintedBlinds from './Pages/PrintedBlinds/PrintedBlinds';
import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import Products from './Pages/Products/Products';
import FilterFabricContent from './Pages/ProductsSubPage/FilterFabric/FilterFabricContent';
import ShippingPolicy from './Pages/ShippingPolicy/ShippingPolicy';
import SpecialSolutions from './Pages/SpecialSolution/SpecialSolutions';
import TermsConditions from './Pages/TermsConditions/TermsConditions';
import Trade from './Pages/Trade/Tade';
import VideosGallery from './Pages/VideosGallery/VideosGallery';
import WhyMarvel from './Pages/WhyMarvel/WhyMarvel';

//Investores Pages 

import CodeOfConduct from './Pages/Investors/CodeOfConduct/CodeOfConduct';
import CompanyFactSheet from './Pages/Investors/CompanyFactSheet/CompanyFactSheet';
import EGM from './Pages/Investors/EGM/EGM';
import Annual_Report from './Pages/Investors/FinancialResults_AnnualReport/AnnualReport/AnnualReport';
import Year_Wise_Annual_Report from './Pages/Investors/FinancialResults_AnnualReport/AnnualReport/Year_Wise_Annual_Report';
import FinancialResults_AnnualReports from './Pages/Investors/FinancialResults_AnnualReport/FinancialResults_AnnualReport';
import InverstoreGrievance from './Pages/Investors/InvestorGrievance/InvestorGrievance';
import Management from './Pages/Investors/Management/Management';
import Policies from './Pages/Investors/Policies/Policies';
import Preferential_issue from './Pages/Investors/Preferential_Issue/Preferential_Issue';
import PrefIssueTwentyFour from './Pages/Investors/Preferential_Issue/Preferential_Issue_TwentyFour';
import Statement_of_deviation_or_variation from './Pages/Investors/Preferential_Issue/statement-of-deviation-or-variation';
import WarrantsTwentySix from './Pages/Investors/Preferential_Issue/Warrants_TwentySix';
import ShareHolding_Pattern from './Pages/Investors/ShareholdingPattern/ShareholdingPattern';
import SC from './Pages/Investors/SubsidiaryCompany/SC_UI';
import SubsidiaryCompany from './Pages/Investors/SubsidiaryCompany/SubsidiaryCompany';
import Updates from './Pages/Investors/Updates/Updates';
import UpdatesUI from './Pages/Investors/Updates/UpdatesUI';

//import Blog Post UI
import BlogPost_UI from './Pages/Blogs/BlogsPageUI/BlogsPageUI';

//import Product page UI
import ProductPageUI from './Pages/ProductsSubPage/ProductPageUI/ProductPageUI';

//import News Post UI
import NewsPost_UI from './Pages/News/NewsPost_UI/NewsPost_UI';

//import Job From UI

import JobApplyForm_UI from './Pages/Carrer/PageComponent/JobApplyForm_UI';

//import Product OS UI

import Product_OS_UI from './Pages/OperatingSystems/Product_OS_UI/Product_OS_UI';

//import Video Page UI
import VideoPage_UI from './Pages/VideosGallery/VideoPageUI/VideoPageUI';

//import Events Images Gallery UI

import EventGallery from './Pages/Events/EventGallery/EventGallery';

//import Exhibitions Images Gallery UI

import ExhibitionsGallery from './Pages/Exhibitions/ExhibitionGallery/ExhibitionGallery';

function App() {
  return (
    <Router>

      <ScrollToTop />

      <Routes>

        {/* Define URL For Websites Pages */}

        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/WhyMarvel" element={<WhyMarvel />} />
        <Route path="/presence" element={<Presence />} />
        <Route path="/photos-gallery" element={<PhotosGallery />} />
        <Route path="/videos-gallery" element={<VideosGallery />} />
        <Route path="/products" element={<Products />} />
        <Route path="/find-dealer" element={<Trade />} />
        <Route path="/special-solutions" element={<SpecialSolutions />} />
        <Route path="/inspiration" element={<Inspiration />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/career" element={<Career />} />
        <Route path="/career/jobs" element={<Jobs />} />
        <Route path="/operating-systems" element={<OperatingSystems />} />
        <Route path="/light-control-privacy" element={<LCP />} />
        <Route path="/innovation" element={<Innovation />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/energy-efficiency" element={<EnergyEfficiency />} />
        <Route path="/fabric-shade" element={<FabricShade />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/news" element={<News />} />
        <Route path="/frequently-asked-questions" element={<FAQ />} />
        <Route path="/filter-inspiration" element={<FilterInspiration />} />
        <Route path="/child-safety" element={<ChildSafety />} />
        <Route path="/events" element={<Events />} />
        <Route path='/exhibitions' element={<Exhibitions />} />

        {/* Investores Pages */}
        <Route path='/company-fact-sheet' element={<CompanyFactSheet />} />
        <Route path='/management' element={<Management />} />
        <Route path='/marvel-decor-egm' element={<EGM />} />
        <Route path='/policies' element={<Policies />} />
        <Route path='/shareholding-pattern' element={<ShareHolding_Pattern />} />
        <Route path='/investor-grievance' element={<InverstoreGrievance />} />
        <Route path='/preferential-issue' element={<Preferential_issue />} />
        <Route path='/preferential-issue-2024' element={<PrefIssueTwentyFour />} />
        <Route path='/pref-issue-warrant-2026' element={<WarrantsTwentySix />} />
        <Route path='/code-of-conduct' element={<CodeOfConduct />} />
        <Route path='/updates' element={<Updates />} />
        <Route path='/financial-results' element={<FinancialResults_AnnualReports />} />
        <Route path='/subsidiary-company' element={<SubsidiaryCompany />} />
        <Route path='/statement-of-deviation-or-variation' element={<Statement_of_deviation_or_variation />} />
        <Route path='/annual-report-agm' element={<Annual_Report />} />

        {/* URL for different Year Annual Reports UI */}

        <Route path='/annual-report/:Get_Current_Year' element={<Year_Wise_Annual_Report />} />

        <Route path='/subsidiary-company/:SC_PG_ID' element={<SC />} />

        <Route path='/updates/:Update_pg_ID' element={<UpdatesUI />} />

        {/* URL for different products UI */}

        <Route path="/printed-blinds" element={<PrintedBlinds />} />
        <Route path="/automation" element={<Automation />} />

        {/* Dynamic URL for Products pages */}

        <Route path="/products/:productId" element={<ProductPageUI />} />

        {/* Dynamic URL for Products Fabric pages */}

        <Route path="/products/:productId/:ProductFabricId" element={<FilterFabricContent />} />

        {/* Dynamic URL for Blog Posts */}

        <Route path="/blog/:Blog_Posts" element={<BlogPost_UI />} />

        {/* Dynamic URl for News Post Page  */}

        <Route path="/news/:News_Post_Id" element={<NewsPost_UI />} />

        {/* Dynamic URl for job Post Page  */}

        <Route path="/job/:JobPagesID" element={<JobApplyForm_UI />} />

        {/* Dynamic URl for Product OS Pages  */}

        <Route path="/:ProductOS_PG_ID" element={<Product_OS_UI />} />

        {/* Dynamic URl for News Post Page  */}

        <Route path="/videos/:Video_PageID" element={<VideoPage_UI />} />

        {/* Dynamic URl for Events Gallery Pages  */}

        <Route path="/events/:EventID" element={<EventGallery />} />

        {/* Dynamic URl for Exhibitions Gallery Pages  */}

        <Route path="/Exhibitions/:ExhibitionsID" element={<ExhibitionsGallery />} />

        {/* Fallback URL If Page Not Found */}

        <Route path="*" element={<h1>Not Found</h1>} />
      </Routes>
    </Router>
  );
}

export default App;
